import Stage from "../../../managers/helpers/stage";
import {uuid, isNumber, windowBounds, extend} from "../../../utils/core";
import throttle from 'lodash/throttle'

class ExStage extends Stage{
	constructor(_options, rendition) {
		super(_options);

		this._isShowingAlert = false;

		this._rendition = rendition;

		this.scaler = this.createScaler(this.settings);
		this.container.appendChild(this.scaler);

		this.alert = this.createAlert(this.settings);
		this.container.appendChild(this.alert);

		//this.updateCreate(this.settings);

		//container overflow setting;
		this._overFlowValue = null;
		this._isPauseScrolling = false;
	}

	/*
	* Creates an element to render to.
	* Resizes to passed width and height or to the elements size
	*/
	create(options){
		let height  = options.height;// !== false ? options.height : "100%";
		let width   = options.width;// !== false ? options.width : "100%";
		let overflow  = options.overflow || false;
		let axis = options.axis || "vertical";
		let direction = options.direction;

		extend(this.settings, options);

		if(options.height && isNumber(options.height)) {
			height = options.height + "px";
		}

		if(options.width && isNumber(options.width)) {
			width = options.width + "px";
		}

		// Create new container element
		let container = document.createElement("div");

		container.id = this.id;
		container.classList.add("epub-container");

		// Style Element
		// container.style.fontSize = "0";
		container.style.wordSpacing = "0";
		container.style.lineHeight = "0";
		container.style.verticalAlign = "top";
		container.style.position = "relative";

		if(axis === "horizontal") {
			// container.style.whiteSpace = "nowrap";
			container.style.display = "flex";
			container.style.flexDirection = "row";
			container.style.flexWrap = "nowrap";
		}

		if(width){
			container.style.width = width;
		}

		if(height){
			container.style.height = height;
		}

		/*if (overflow) {
			if (overflow === "scroll" && axis === "vertical") {
				container.style["overflow-y"] = overflow;
				container.style["overflow-x"] = "hidden";
			} else if (overflow === "scroll" && axis === "horizontal") {
				container.style["overflow-y"] = "hidden";
				container.style["overflow-x"] = overflow;
			} else {
				container.style["overflow"] = overflow;
			}
		}*/

		container.style["overflow"] = "hidden";

		if (direction) {
			container.dir = direction;
			container.style["direction"] = direction;
		}

		if (direction && this.settings.fullsize) {
			document.body.style["direction"] = direction;
		}

		return container;
	}

	pauseScrolling(){
		if(!this._isPauseScrolling){
			//console.log("%c==PAUSE SCROLLING==","font-weight: bold; color: red");
			this._overFlowValue = this.scaler.style.overflow;
			this.scaler.style.overflow = 'hidden';
			this._isPauseScrolling = true;
		}
	}

	recoverScrolling(){
		if(this._isPauseScrolling){
			//console.log("%c==RECOVER SCROLLING==","font-weight: bold; color: green");
			this._overFlowValue = (this._overFlowValue) ? this._overFlowValue : this.scaler.style.overflow;
			this.scaler.style.overflow = this._overFlowValue;
			this._isPauseScrolling = false;
		}
	}

	size(width, height){
		var bounds;
		let _width = width || this.settings.width;
		let _height = height || this.settings.height;

		// If width or height are set to false, inherit them from containing element
		if(width === null || width === undefined) {
			bounds = this.element.getBoundingClientRect();

			if(bounds.width) {
				width = Math.floor(bounds.width);
				this.container.style.width = width + "px";
			}
		} else {
			if (isNumber(width)) {
				this.container.style.width = width + "px";
			} else {
				this.container.style.width = width;
			}
		}

		if(height === null || height === undefined) {
			bounds = bounds || this.element.getBoundingClientRect();

			if(bounds.height) {
				height = bounds.height;
				this.container.style.height = height + "px";
			}

		} else {
			if (isNumber(height)) {
				this.container.style.height = height + "px";
			} else {
				this.container.style.height = height;
			}
		}

		if(!isNumber(width)) {
			width = this.container.clientWidth;
		}

		if(!isNumber(height)) {
			height = this.container.clientHeight;
		}

		this.containerStyles = window.getComputedStyle(this.container);

		this.containerPadding = {
			left: parseFloat(this.containerStyles["padding-left"]) || 0,
			right: parseFloat(this.containerStyles["padding-right"]) || 0,
			top: parseFloat(this.containerStyles["padding-top"]) || 0,
			bottom: parseFloat(this.containerStyles["padding-bottom"]) || 0
		};

		// Bounds not set, get them from window
		let _windowBounds = windowBounds();
		let bodyStyles = window.getComputedStyle(document.body);
		let bodyPadding = {
			left: parseFloat(bodyStyles["padding-left"]) || 0,
			right: parseFloat(bodyStyles["padding-right"]) || 0,
			top: parseFloat(bodyStyles["padding-top"]) || 0,
			bottom: parseFloat(bodyStyles["padding-bottom"]) || 0
		};

		if (!_width) {
			width = _windowBounds.width -
								bodyPadding.left -
								bodyPadding.right;
		}

		if ((this.settings.fullsize && !_height) || !_height) {
			height = _windowBounds.height -
								bodyPadding.top -
								bodyPadding.bottom;
		}

		return {
			width: width -
							this.containerPadding.left -
							this.containerPadding.right,
			height: height -
							this.containerPadding.top -
							this.containerPadding.bottom
		};

	}

	createAlert(options){
		let height  = options.height;// !== false ? options.height : "100%";
		let width   = options.width;// !== false ? options.width : "100%";

		if(options.height && isNumber(options.height)) {
			height = options.height + "px";
		}

		if(options.width && isNumber(options.width)) {
			width = options.width + "px";
		}

		// Create new alert element
		let alert = document.createElement("div");

		alert.innerHTML = '<svg class="epub-alert-v-start" width="165" height="57" viewBox="0 0 165 57" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="m11.411 43.624 67.39 12.68a20 20 0 0 0 7.397 0l67.39-12.68A14 14 0 0 0 165 29.866V11c0-6.075-4.925-11-11-11H11C4.925 0 0 4.925 0 11v18.866a14 14 0 0 0 11.411 13.758z" fill-opacity=".95" fill="#727272" fill-rule="nonzero"/><g fill="#FFF"><g fill-rule="nonzero"><path d="M42.525 22.54v-6h-11.1v1.05H41.43v3.915h-8.325v-2.22h-1.08v7.875c0 1.23.6 1.86 1.815 1.86h8.13c.63-.03 1.125-.195 1.455-.51.36-.39.615-1.5.765-3.36l-1.05-.33c-.09 1.65-.285 2.61-.585 2.88-.225.18-.525.27-.885.27h-7.53c-.69 0-1.035-.345-1.035-1.005V22.54h9.42zM54.81 24.985v3.165h-3.63v1.005h8.22V28.15h-3.555v-3.165h3.06v-.99H51.75v.99h3.06zm-3.375-8.67v.99h7.77v-.99h-7.77zm1.185 1.47c-.39.975-.9 1.92-1.53 2.835.63.84 1.185 1.8 1.695 2.88l.885-.51c-.54-1.02-1.05-1.815-1.53-2.4.48-.63.96-1.44 1.41-2.415l-.93-.39zm2.76.03c-.39.96-.885 1.905-1.515 2.805.63.825 1.185 1.77 1.695 2.835l.87-.51c-.525-.99-1.035-1.785-1.515-2.355.48-.63.93-1.425 1.38-2.385l-.915-.39zm2.82.015c-.39.96-.915 1.89-1.545 2.79.63.825 1.2 1.77 1.71 2.835l.87-.51c-.54-.99-1.05-1.785-1.545-2.355.495-.63.975-1.41 1.425-2.37l-.915-.39zm-11.97 7.875c-.06 1.23-.255 2.325-.57 3.27l.96.3c.285-1.005.465-2.16.555-3.45l-.945-.12zm2.58-.135-.9.195c.18.87.33 1.86.45 3l.96-.21a53.22 53.22 0 0 0-.51-2.985zm1.335-3.87-.825.27c.15.405.3.825.435 1.275-.84.24-1.68.45-2.52.615.945-1.095 2.16-2.985 3.63-5.685l-.96-.36c-.405.78-.795 1.515-1.155 2.175-.645.12-1.29.225-1.92.3.72-1.05 1.41-2.445 2.1-4.185l-.975-.39c-.54 1.59-1.17 3.015-1.89 4.245-.12.18-.27.315-.435.39l.27.96 2.295-.36c-.75 1.275-1.41 2.19-1.965 2.76-.135.12-.285.21-.465.285l.27.945c1.26-.165 2.58-.45 3.975-.87.06.27.135.54.21.84l.885-.225c-.27-1.125-.6-2.115-.96-2.985zm.36 3.525-.84.27c.24.78.45 1.59.615 2.46l.9-.24c-.195-.945-.42-1.77-.675-2.49zM63 16.255v5.205h9.12v-5.205H63zm8.055 4.29h-6.99v-1.23h6.99v1.23zm-6.99-2.115v-1.245h6.99v1.245h-6.99zm3.06 5.13v4.485a7.291 7.291 0 0 1-.825-.21c-.78-.285-1.5-.945-2.13-1.995.195-.495.36-1.02.51-1.575l-1.02-.18c-.495 1.875-1.44 3.375-2.82 4.485l.705.885c.9-.735 1.65-1.65 2.235-2.76.6.99 1.29 1.65 2.055 1.995.885.375 2.565.57 5.04.57.855.015 1.815.03 2.895.03l.3-1.02c-.885.03-1.98.045-3.27.045-.99 0-1.86-.045-2.58-.105v-1.995h4.32v-.96h-4.32V23.56h5.925v-.99H60.87v.99h6.255zM87.285 20.47v-1.53h1.785v-.885h-1.785V16.51H83.04v-.81h-1.095v.81h-4.5v.78h4.56v.84H76.11v.735h5.895v.825h-4.53v.78h4.485v.735h-4.785v.765h4.785v.78h-5.88v.81h12.84v-.81h-5.91v-.78h4.83v-.765h-4.83v-.735h4.275zm-4.32-3.18h3.3v.84h-3.3v-.84zm0 1.575h3.3v.825h-3.3v-.825zm4.485 5.52h-9.72v5.175h1.05v-.69h7.62v.69h1.05v-5.175zm-8.67 3.645v-.99h7.62v.99h-7.62zm0-1.8v-1.035h7.62v1.035h-7.62zM97.215 20.11v.93h1.395v1.335h-1.755v.93h7.185v-.93h-1.785V21.04h1.365v-.93h-1.365v-1.065h-.96v1.065h-1.74v-1.065h-.945v1.065h-1.395zm2.34 2.265V21.04h1.74v1.335h-1.74zm3.765 1.71h-5.64v5.43h.99V28.9h3.675v.615h.975v-5.43zM98.67 28v-1.11h3.675V28H98.67zm0-1.935v-1.08h3.675v1.08H98.67zm-5.64-8.505h1.2c.33.42.63.87.885 1.32l.915-.33a7.03 7.03 0 0 0-.69-.99h1.935v-.93h-3.69c.12-.24.225-.48.345-.735l-.99-.225c-.45 1.065-1.155 2.04-2.145 2.91l.885.555a9.61 9.61 0 0 0 1.35-1.575zm6.15 0h.945c.33.42.63.87.87 1.335l.915-.345a8.321 8.321 0 0 0-.675-.99h2.91v-.93H99.69c.12-.255.225-.525.345-.81l-.99-.21c-.36.96-.945 1.845-1.74 2.64l.9.57c.36-.39.675-.81.975-1.26zm-7.665 4.275v.87h1.995v1.065h-2.385v.885h2.28c-.6 1.05-1.575 1.98-2.895 2.805l.39 1.02c1.08-.825 1.95-1.755 2.61-2.79v3.81h.975v-3.555c.54.435 1.185 1.02 1.95 1.755l.57-.855a26.078 26.078 0 0 0-2.52-1.725v-.465h2.145v-.885h-2.145v-1.065h1.8v-.87h-1.8V20.77c.84-.09 1.53-.21 2.085-.33l-.3-.855c-.48.135-1.065.255-1.785.345v-.99h-.975v1.095c-.675.06-1.44.105-2.28.135l.255.825c.72-.03 1.395-.075 2.025-.135v.975h-1.995zM108.375 24.67v.96h1.92c-.075.51-.195.975-.36 1.365-.3.6-.825 1.08-1.56 1.44l.54.855c.84-.39 1.455-.945 1.815-1.65.27-.54.45-1.215.54-2.01h2.34v3.45h.99v-3.45h1.935v-.96H114.6v-1.725h1.455v-.93h-7.275v.93h1.59v1.725h-1.995zm5.235 0h-2.265v-1.725h2.265v1.725zm-6.225-5.715h3.375v1.095h-3.375v-1.095zm3.375-.765h-3.375v-1.155h3.375v1.155zm3.36.765h3.465v1.065h-3.465v-1.065zm3.465-.765h-3.465v-1.125h3.465v1.125zm-5.775-2.01h-5.505v13.185h1.08V20.92h4.425v-4.74zm5.775 4.695v6.615c0 .57-.225.87-.675.87-.45 0-.945-.03-1.485-.06l.255.96c.54.03 1.08.045 1.62.045.9 0 1.35-.495 1.35-1.485V16.195h-5.58v4.68h4.515zM127.38 18.655v7.815h6.285v-7.815h-2.88c.12-.435.21-.87.27-1.32h3.27v-.975h-7.5v.975h3.18c-.06.45-.135.885-.24 1.32h-2.385zm5.265 6.87H128.4V24.07h4.245v1.455zM128.4 23.17v-1.305h4.245v1.305H128.4zm0-2.205V19.54h4.245v1.425H128.4zm.75 5.7c-.69.795-1.545 1.485-2.535 2.085l.63.825a10.79 10.79 0 0 0 2.64-2.25l-.735-.66zm2.835-.015-.675.645c1.005.78 1.8 1.5 2.37 2.19l.72-.705c-.66-.72-1.455-1.425-2.415-2.13zm-11.22-10.14v1.005h5.535V16.51h-5.535zM121.2 19v4.335h4.785V19H121.2zm3.825 3.405h-2.865V19.93h2.865v2.475zm1.32 4.635c-.45.09-.93.195-1.425.3.33-.9.615-1.92.885-3.06l-.93-.33a31.456 31.456 0 0 1-1.005 3.57c-.975.15-2.04.285-3.18.405l.135.99a50.81 50.81 0 0 0 5.52-.885v-.99zm-4.185-2.97-.87.27c.345.87.63 1.785.84 2.745l.885-.24a22.705 22.705 0 0 0-.855-2.775z"/></g><path opacity=".3" d="m82 45 7-8H75z"/></g></g></svg><svg class="epub-alert-h-start" width="57" height="165" viewBox="0 0 57 165" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M13.376 11.411.696 78.801a20 20 0 0 0 0 7.397l12.68 67.39A14 14 0 0 0 27.134 165H46c6.075 0 11-4.925 11-11V11c0-6.075-4.925-11-11-11H27.134a14 14 0 0 0-13.758 11.411z" fill-opacity=".95" fill="#727272" fill-rule="nonzero"/><path fill="#FFF" opacity=".3" d="m12 83 8 7V76z"/><g fill="#FFF" fill-rule="nonzero"><path d="M38.525 31.54v-6h-11.1v1.05H37.43v3.915h-8.325v-2.22h-1.08v7.875c0 1.23.6 1.86 1.815 1.86h8.13c.63-.03 1.125-.195 1.455-.51.36-.39.615-1.5.765-3.36l-1.05-.33c-.09 1.65-.285 2.61-.585 2.88-.225.18-.525.27-.885.27h-7.53c-.69 0-1.035-.345-1.035-1.005V31.54h9.42zM35.81 50.985v3.165h-3.63v1.005h8.22V54.15h-3.555v-3.165h3.06v-.99H32.75v.99h3.06zm-3.375-8.67v.99h7.77v-.99h-7.77zm1.185 1.47c-.39.975-.9 1.92-1.53 2.835.63.84 1.185 1.8 1.695 2.88l.885-.51c-.54-1.02-1.05-1.815-1.53-2.4.48-.63.96-1.44 1.41-2.415l-.93-.39zm2.76.03c-.39.96-.885 1.905-1.515 2.805.63.825 1.185 1.77 1.695 2.835l.87-.51c-.525-.99-1.035-1.785-1.515-2.355.48-.63.93-1.425 1.38-2.385l-.915-.39zm2.82.015c-.39.96-.915 1.89-1.545 2.79.63.825 1.2 1.77 1.71 2.835l.87-.51c-.54-.99-1.05-1.785-1.545-2.355.495-.63.975-1.41 1.425-2.37l-.915-.39zm-11.97 7.875c-.06 1.23-.255 2.325-.57 3.27l.96.3c.285-1.005.465-2.16.555-3.45l-.945-.12zm2.58-.135-.9.195c.18.87.33 1.86.45 3l.96-.21a53.22 53.22 0 0 0-.51-2.985zm1.335-3.87-.825.27c.15.405.3.825.435 1.275-.84.24-1.68.45-2.52.615.945-1.095 2.16-2.985 3.63-5.685l-.96-.36c-.405.78-.795 1.515-1.155 2.175-.645.12-1.29.225-1.92.3.72-1.05 1.41-2.445 2.1-4.185l-.975-.39c-.54 1.59-1.17 3.015-1.89 4.245-.12.18-.27.315-.435.39l.27.96 2.295-.36c-.75 1.275-1.41 2.19-1.965 2.76-.135.12-.285.21-.465.285l.27.945c1.26-.165 2.58-.45 3.975-.87.06.27.135.54.21.84l.885-.225c-.27-1.125-.6-2.115-.96-2.985zm.36 3.525-.84.27c.24.78.45 1.59.615 2.46l.9-.24c-.195-.945-.42-1.77-.675-2.49zM29 59.255v5.205h9.12v-5.205H29zm8.055 4.29h-6.99v-1.23h6.99v1.23zm-6.99-2.115v-1.245h6.99v1.245h-6.99zm3.06 5.13v4.485a7.291 7.291 0 0 1-.825-.21c-.78-.285-1.5-.945-2.13-1.995.195-.495.36-1.02.51-1.575l-1.02-.18c-.495 1.875-1.44 3.375-2.82 4.485l.705.885c.9-.735 1.65-1.65 2.235-2.76.6.99 1.29 1.65 2.055 1.995.885.375 2.565.57 5.04.57.855.015 1.815.03 2.895.03l.3-1.02c-.885.03-1.98.045-3.27.045-.99 0-1.86-.045-2.58-.105v-1.995h4.32v-.96h-4.32V66.56h5.925v-.99H26.87v.99h6.255zM38.285 80.47v-1.53h1.785v-.885h-1.785V76.51H34.04v-.81h-1.095v.81h-4.5v.78h4.56v.84H27.11v.735h5.895v.825h-4.53v.78h4.485v.735h-4.785v.765h4.785v.78h-5.88v.81h12.84v-.81h-5.91v-.78h4.83v-.765h-4.83v-.735h4.275zm-4.32-3.18h3.3v.84h-3.3v-.84zm0 1.575h3.3v.825h-3.3v-.825zm4.485 5.52h-9.72v5.175h1.05v-.69h7.62v.69h1.05v-5.175zm-8.67 3.645v-.99h7.62v.99h-7.62zm0-1.8v-1.035h7.62v1.035h-7.62zM33.215 97.11v.93h1.395v1.335h-1.755v.93h7.185v-.93h-1.785V98.04h1.365v-.93h-1.365v-1.065h-.96v1.065h-1.74v-1.065h-.945v1.065h-1.395zm2.34 2.265V98.04h1.74v1.335h-1.74zm3.765 1.71h-5.64v5.43h.99v-.615h3.675v.615h.975v-5.43zM34.67 105v-1.11h3.675V105H34.67zm0-1.935v-1.08h3.675v1.08H34.67zm-5.64-8.505h1.2c.33.42.63.87.885 1.32l.915-.33a7.03 7.03 0 0 0-.69-.99h1.935v-.93h-3.69c.12-.24.225-.48.345-.735l-.99-.225c-.45 1.065-1.155 2.04-2.145 2.91l.885.555a9.61 9.61 0 0 0 1.35-1.575zm6.15 0h.945c.33.42.63.87.87 1.335l.915-.345a8.321 8.321 0 0 0-.675-.99h2.91v-.93H35.69c.12-.255.225-.525.345-.81l-.99-.21c-.36.96-.945 1.845-1.74 2.64l.9.57c.36-.39.675-.81.975-1.26zm-7.665 4.275v.87h1.995v1.065h-2.385v.885h2.28c-.6 1.05-1.575 1.98-2.895 2.805l.39 1.02c1.08-.825 1.95-1.755 2.61-2.79v3.81h.975v-3.555c.54.435 1.185 1.02 1.95 1.755l.57-.855a26.078 26.078 0 0 0-2.52-1.725v-.465h2.145v-.885h-2.145v-1.065h1.8v-.87h-1.8V97.77c.84-.09 1.53-.21 2.085-.33l-.3-.855c-.48.135-1.065.255-1.785.345v-.99h-.975v1.095c-.675.06-1.44.105-2.28.135l.255.825c.72-.03 1.395-.075 2.025-.135v.975h-1.995zM29.375 118.67v.96h1.92c-.075.51-.195.975-.36 1.365-.3.6-.825 1.08-1.56 1.44l.54.855c.84-.39 1.455-.945 1.815-1.65.27-.54.45-1.215.54-2.01h2.34v3.45h.99v-3.45h1.935v-.96H35.6v-1.725h1.455v-.93H29.78v.93h1.59v1.725h-1.995zm5.235 0h-2.265v-1.725h2.265v1.725zm-6.225-5.715h3.375v1.095h-3.375v-1.095zm3.375-.765h-3.375v-1.155h3.375v1.155zm3.36.765h3.465v1.065H35.12v-1.065zm3.465-.765H35.12v-1.125h3.465v1.125zm-5.775-2.01h-5.505v13.185h1.08v-8.445h4.425v-4.74zm5.775 4.695v6.615c0 .57-.225.87-.675.87-.45 0-.945-.03-1.485-.06l.255.96c.54.03 1.08.045 1.62.045.9 0 1.35-.495 1.35-1.485v-11.625h-5.58v4.68h4.515zM33.38 129.655v7.815h6.285v-7.815h-2.88c.12-.435.21-.87.27-1.32h3.27v-.975h-7.5v.975h3.18c-.06.45-.135.885-.24 1.32H33.38zm5.265 6.87H34.4v-1.455h4.245v1.455zM34.4 134.17v-1.305h4.245v1.305H34.4zm0-2.205v-1.425h4.245v1.425H34.4zm.75 5.7c-.69.795-1.545 1.485-2.535 2.085l.63.825a10.79 10.79 0 0 0 2.64-2.25l-.735-.66zm2.835-.015-.675.645c1.005.78 1.8 1.5 2.37 2.19l.72-.705c-.66-.72-1.455-1.425-2.415-2.13zm-11.22-10.14v1.005H32.3v-1.005h-5.535zM27.2 130v4.335h4.785V130H27.2zm3.825 3.405H28.16v-2.475h2.865v2.475zm1.32 4.635c-.45.09-.93.195-1.425.3.33-.9.615-1.92.885-3.06l-.93-.33a31.456 31.456 0 0 1-1.005 3.57c-.975.15-2.04.285-3.18.405l.135.99a50.81 50.81 0 0 0 5.52-.885v-.99zm-4.185-2.97-.87.27c.345.87.63 1.785.84 2.745l.885-.24a22.705 22.705 0 0 0-.855-2.775z"/></g></g></svg><svg class="epub-alert-v-end" width="165" height="57" viewBox="0 0 165 57" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M153.589 13.376 86.199.696a20 20 0 0 0-7.397 0l-67.39 12.68A14 14 0 0 0 0 27.134V46c0 6.075 4.925 11 11 11h143c6.075 0 11-4.925 11-11V27.134a14 14 0 0 0-11.411-13.758z" fill-opacity=".95" fill="#727272" fill-rule="nonzero"/><g fill="#FFF" fill-rule="nonzero"><path d="M42.525 34.54v-6h-11.1v1.05H41.43v3.915h-8.325v-2.22h-1.08v7.875c0 1.23.6 1.86 1.815 1.86h8.13c.63-.03 1.125-.195 1.455-.51.36-.39.615-1.5.765-3.36l-1.05-.33c-.09 1.65-.285 2.61-.585 2.88-.225.18-.525.27-.885.27h-7.53c-.69 0-1.035-.345-1.035-1.005V34.54h9.42zM54.81 36.985v3.165h-3.63v1.005h8.22V40.15h-3.555v-3.165h3.06v-.99H51.75v.99h3.06zm-3.375-8.67v.99h7.77v-.99h-7.77zm1.185 1.47c-.39.975-.9 1.92-1.53 2.835.63.84 1.185 1.8 1.695 2.88l.885-.51c-.54-1.02-1.05-1.815-1.53-2.4.48-.63.96-1.44 1.41-2.415l-.93-.39zm2.76.03c-.39.96-.885 1.905-1.515 2.805.63.825 1.185 1.77 1.695 2.835l.87-.51c-.525-.99-1.035-1.785-1.515-2.355.48-.63.93-1.425 1.38-2.385l-.915-.39zm2.82.015c-.39.96-.915 1.89-1.545 2.79.63.825 1.2 1.77 1.71 2.835l.87-.51c-.54-.99-1.05-1.785-1.545-2.355.495-.63.975-1.41 1.425-2.37l-.915-.39zm-11.97 7.875c-.06 1.23-.255 2.325-.57 3.27l.96.3c.285-1.005.465-2.16.555-3.45l-.945-.12zm2.58-.135-.9.195c.18.87.33 1.86.45 3l.96-.21a53.22 53.22 0 0 0-.51-2.985zm1.335-3.87-.825.27c.15.405.3.825.435 1.275-.84.24-1.68.45-2.52.615.945-1.095 2.16-2.985 3.63-5.685l-.96-.36c-.405.78-.795 1.515-1.155 2.175-.645.12-1.29.225-1.92.3.72-1.05 1.41-2.445 2.1-4.185l-.975-.39c-.54 1.59-1.17 3.015-1.89 4.245-.12.18-.27.315-.435.39l.27.96 2.295-.36c-.75 1.275-1.41 2.19-1.965 2.76-.135.12-.285.21-.465.285l.27.945c1.26-.165 2.58-.45 3.975-.87.06.27.135.54.21.84l.885-.225c-.27-1.125-.6-2.115-.96-2.985zm.36 3.525-.84.27c.24.78.45 1.59.615 2.46l.9-.24c-.195-.945-.42-1.77-.675-2.49zM63 28.255v5.205h9.12v-5.205H63zm8.055 4.29h-6.99v-1.23h6.99v1.23zm-6.99-2.115v-1.245h6.99v1.245h-6.99zm3.06 5.13v4.485a7.291 7.291 0 0 1-.825-.21c-.78-.285-1.5-.945-2.13-1.995.195-.495.36-1.02.51-1.575l-1.02-.18c-.495 1.875-1.44 3.375-2.82 4.485l.705.885c.9-.735 1.65-1.65 2.235-2.76.6.99 1.29 1.65 2.055 1.995.885.375 2.565.57 5.04.57.855.015 1.815.03 2.895.03l.3-1.02c-.885.03-1.98.045-3.27.045-.99 0-1.86-.045-2.58-.105v-1.995h4.32v-.96h-4.32V35.56h5.925v-.99H60.87v.99h6.255zM87.285 32.47v-1.53h1.785v-.885h-1.785V28.51H83.04v-.81h-1.095v.81h-4.5v.78h4.56v.84H76.11v.735h5.895v.825h-4.53v.78h4.485v.735h-4.785v.765h4.785v.78h-5.88v.81h12.84v-.81h-5.91v-.78h4.83v-.765h-4.83v-.735h4.275zm-4.32-3.18h3.3v.84h-3.3v-.84zm0 1.575h3.3v.825h-3.3v-.825zm4.485 5.52h-9.72v5.175h1.05v-.69h7.62v.69h1.05v-5.175zm-8.67 3.645v-.99h7.62v.99h-7.62zm0-1.8v-1.035h7.62v1.035h-7.62zM97.215 32.11v.93h1.395v1.335h-1.755v.93h7.185v-.93h-1.785V33.04h1.365v-.93h-1.365v-1.065h-.96v1.065h-1.74v-1.065h-.945v1.065h-1.395zm2.34 2.265V33.04h1.74v1.335h-1.74zm3.765 1.71h-5.64v5.43h.99V40.9h3.675v.615h.975v-5.43zM98.67 40v-1.11h3.675V40H98.67zm0-1.935v-1.08h3.675v1.08H98.67zm-5.64-8.505h1.2c.33.42.63.87.885 1.32l.915-.33a7.03 7.03 0 0 0-.69-.99h1.935v-.93h-3.69c.12-.24.225-.48.345-.735l-.99-.225c-.45 1.065-1.155 2.04-2.145 2.91l.885.555a9.61 9.61 0 0 0 1.35-1.575zm6.15 0h.945c.33.42.63.87.87 1.335l.915-.345a8.321 8.321 0 0 0-.675-.99h2.91v-.93H99.69c.12-.255.225-.525.345-.81l-.99-.21c-.36.96-.945 1.845-1.74 2.64l.9.57c.36-.39.675-.81.975-1.26zm-7.665 4.275v.87h1.995v1.065h-2.385v.885h2.28c-.6 1.05-1.575 1.98-2.895 2.805l.39 1.02c1.08-.825 1.95-1.755 2.61-2.79v3.81h.975v-3.555c.54.435 1.185 1.02 1.95 1.755l.57-.855a26.078 26.078 0 0 0-2.52-1.725v-.465h2.145v-.885h-2.145v-1.065h1.8v-.87h-1.8V32.77c.84-.09 1.53-.21 2.085-.33l-.3-.855c-.48.135-1.065.255-1.785.345v-.99h-.975v1.095c-.675.06-1.44.105-2.28.135l.255.825c.72-.03 1.395-.075 2.025-.135v.975h-1.995zM106.29 37.705c-.06 1.23-.24 2.31-.54 3.27l.975.285c.285-.99.465-2.145.54-3.435l-.975-.12zm2.565-.225-.885.195c.18.9.33 1.92.465 3.09l1.005-.225c-.18-1.11-.375-2.13-.585-3.06zm1.485-3.81-.855.27c.15.435.3.885.45 1.35-.87.225-1.725.405-2.565.555.93-1.02 2.1-2.79 3.54-5.31l-1.005-.36c-.36.645-.69 1.26-1.02 1.83-.63.105-1.275.195-1.905.27.75-1.05 1.5-2.445 2.235-4.17l-1.035-.405c-.57 1.59-1.23 3.015-2.01 4.245-.135.195-.285.33-.45.405l.27.99c.78-.12 1.56-.24 2.31-.36-.78 1.26-1.44 2.16-1.995 2.7-.135.12-.3.225-.495.3l.285.99c1.29-.165 2.655-.45 4.065-.87.06.24.12.495.18.75l.9-.24c-.27-1.11-.57-2.085-.9-2.94zm.255 3.42-.84.27c.315.78.6 1.665.87 2.655l.9-.39c-.27-.9-.57-1.755-.93-2.535zm.465-7.41v1.035h3.63v2.28h-3.225v1.035h7.545v-1.035h-3.255v-2.28h3.585V29.68h-3.585v-1.92h-1.065v1.92h-3.63zm7.47 5.805h-6.54V41.5h1.05v-.69h4.44v.69h1.05v-6.015zm-5.49 4.305v-3.285h4.44v3.285h-4.44zM131.955 29.35v1.74h-8.58v-1.74h8.58zm-8.58 2.73h9.675v-3.75h-10.755v4.98c-.015 3.015-.555 5.475-1.605 7.395l.84.735c1.215-2.265 1.83-4.98 1.845-8.13v-1.23zm8.79 9.21c.57 0 .99-.09 1.26-.27.3-.225.51-.825.6-1.815l-.945-.315c-.06.69-.18 1.095-.36 1.245-.15.105-.39.165-.735.165h-2.955c-.285 0-.42-.18-.42-.54v-1.14l5.25-.48v-.96l-5.25.48v-1.275l4.29-.39v-.915l-4.29.39v-1.275c1.41-.18 2.745-.42 4.02-.705l-.495-.84c-2.16.51-4.83.84-8.025.99l.315.885a68.81 68.81 0 0 0 3.105-.21v1.245l-3.165.285v.93l3.165-.285v1.275l-3.855.36v.945l3.855-.345v1.26c0 .87.39 1.305 1.2 1.305h3.435z"/></g><path fill="#FFF" opacity=".3" d="m83 12 7 8H76z"/></g></svg><svg class="epub-alert-h-end" width="57" height="165" viewBox="0 0 57 165" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="m43.624 11.411 12.68 67.39a20 20 0 0 1 0 7.397l-12.68 67.39A14 14 0 0 1 29.866 165H11c-6.075 0-11-4.925-11-11V11C0 4.925 4.925 0 11 0h18.866a14 14 0 0 1 13.758 11.411z" fill-opacity=".95" fill="#727272" fill-rule="nonzero"/><g fill="#FFF" fill-rule="nonzero"><path d="M28.525 31.54v-6h-11.1v1.05H27.43v3.915h-8.325v-2.22h-1.08v7.875c0 1.23.6 1.86 1.815 1.86h8.13c.63-.03 1.125-.195 1.455-.51.36-.39.615-1.5.765-3.36l-1.05-.33c-.09 1.65-.285 2.61-.585 2.88-.225.18-.525.27-.885.27h-7.53c-.69 0-1.035-.345-1.035-1.005V31.54h9.42zM25.81 50.985v3.165h-3.63v1.005h8.22V54.15h-3.555v-3.165h3.06v-.99H22.75v.99h3.06zm-3.375-8.67v.99h7.77v-.99h-7.77zm1.185 1.47c-.39.975-.9 1.92-1.53 2.835.63.84 1.185 1.8 1.695 2.88l.885-.51c-.54-1.02-1.05-1.815-1.53-2.4.48-.63.96-1.44 1.41-2.415l-.93-.39zm2.76.03c-.39.96-.885 1.905-1.515 2.805.63.825 1.185 1.77 1.695 2.835l.87-.51c-.525-.99-1.035-1.785-1.515-2.355.48-.63.93-1.425 1.38-2.385l-.915-.39zm2.82.015c-.39.96-.915 1.89-1.545 2.79.63.825 1.2 1.77 1.71 2.835l.87-.51c-.54-.99-1.05-1.785-1.545-2.355.495-.63.975-1.41 1.425-2.37l-.915-.39zm-11.97 7.875c-.06 1.23-.255 2.325-.57 3.27l.96.3c.285-1.005.465-2.16.555-3.45l-.945-.12zm2.58-.135-.9.195c.18.87.33 1.86.45 3l.96-.21a53.22 53.22 0 0 0-.51-2.985zm1.335-3.87-.825.27c.15.405.3.825.435 1.275-.84.24-1.68.45-2.52.615.945-1.095 2.16-2.985 3.63-5.685l-.96-.36c-.405.78-.795 1.515-1.155 2.175-.645.12-1.29.225-1.92.3.72-1.05 1.41-2.445 2.1-4.185l-.975-.39c-.54 1.59-1.17 3.015-1.89 4.245-.12.18-.27.315-.435.39l.27.96 2.295-.36c-.75 1.275-1.41 2.19-1.965 2.76-.135.12-.285.21-.465.285l.27.945c1.26-.165 2.58-.45 3.975-.87.06.27.135.54.21.84l.885-.225c-.27-1.125-.6-2.115-.96-2.985zm.36 3.525-.84.27c.24.78.45 1.59.615 2.46l.9-.24c-.195-.945-.42-1.77-.675-2.49zM19 59.255v5.205h9.12v-5.205H19zm8.055 4.29h-6.99v-1.23h6.99v1.23zm-6.99-2.115v-1.245h6.99v1.245h-6.99zm3.06 5.13v4.485a7.291 7.291 0 0 1-.825-.21c-.78-.285-1.5-.945-2.13-1.995.195-.495.36-1.02.51-1.575l-1.02-.18c-.495 1.875-1.44 3.375-2.82 4.485l.705.885c.9-.735 1.65-1.65 2.235-2.76.6.99 1.29 1.65 2.055 1.995.885.375 2.565.57 5.04.57.855.015 1.815.03 2.895.03l.3-1.02c-.885.03-1.98.045-3.27.045-.99 0-1.86-.045-2.58-.105v-1.995h4.32v-.96h-4.32V66.56h5.925v-.99H16.87v.99h6.255zM28.285 80.47v-1.53h1.785v-.885h-1.785V76.51H24.04v-.81h-1.095v.81h-4.5v.78h4.56v.84H17.11v.735h5.895v.825h-4.53v.78h4.485v.735h-4.785v.765h4.785v.78h-5.88v.81h12.84v-.81h-5.91v-.78h4.83v-.765h-4.83v-.735h4.275zm-4.32-3.18h3.3v.84h-3.3v-.84zm0 1.575h3.3v.825h-3.3v-.825zm4.485 5.52h-9.72v5.175h1.05v-.69h7.62v.69h1.05v-5.175zm-8.67 3.645v-.99h7.62v.99h-7.62zm0-1.8v-1.035h7.62v1.035h-7.62zM23.215 97.11v.93h1.395v1.335h-1.755v.93h7.185v-.93h-1.785V98.04h1.365v-.93h-1.365v-1.065h-.96v1.065h-1.74v-1.065h-.945v1.065h-1.395zm2.34 2.265V98.04h1.74v1.335h-1.74zm3.765 1.71h-5.64v5.43h.99v-.615h3.675v.615h.975v-5.43zM24.67 105v-1.11h3.675V105H24.67zm0-1.935v-1.08h3.675v1.08H24.67zm-5.64-8.505h1.2c.33.42.63.87.885 1.32l.915-.33a7.03 7.03 0 0 0-.69-.99h1.935v-.93h-3.69c.12-.24.225-.48.345-.735l-.99-.225c-.45 1.065-1.155 2.04-2.145 2.91l.885.555a9.61 9.61 0 0 0 1.35-1.575zm6.15 0h.945c.33.42.63.87.87 1.335l.915-.345a8.321 8.321 0 0 0-.675-.99h2.91v-.93H25.69c.12-.255.225-.525.345-.81l-.99-.21c-.36.96-.945 1.845-1.74 2.64l.9.57c.36-.39.675-.81.975-1.26zm-7.665 4.275v.87h1.995v1.065h-2.385v.885h2.28c-.6 1.05-1.575 1.98-2.895 2.805l.39 1.02c1.08-.825 1.95-1.755 2.61-2.79v3.81h.975v-3.555c.54.435 1.185 1.02 1.95 1.755l.57-.855a26.078 26.078 0 0 0-2.52-1.725v-.465h2.145v-.885h-2.145v-1.065h1.8v-.87h-1.8V97.77c.84-.09 1.53-.21 2.085-.33l-.3-.855c-.48.135-1.065.255-1.785.345v-.99h-.975v1.095c-.675.06-1.44.105-2.28.135l.255.825c.72-.03 1.395-.075 2.025-.135v.975h-1.995zM17.29 119.705c-.06 1.23-.24 2.31-.54 3.27l.975.285c.285-.99.465-2.145.54-3.435l-.975-.12zm2.565-.225-.885.195c.18.9.33 1.92.465 3.09l1.005-.225c-.18-1.11-.375-2.13-.585-3.06zm1.485-3.81-.855.27c.15.435.3.885.45 1.35-.87.225-1.725.405-2.565.555.93-1.02 2.1-2.79 3.54-5.31l-1.005-.36c-.36.645-.69 1.26-1.02 1.83-.63.105-1.275.195-1.905.27.75-1.05 1.5-2.445 2.235-4.17l-1.035-.405c-.57 1.59-1.23 3.015-2.01 4.245-.135.195-.285.33-.45.405l.27.99c.78-.12 1.56-.24 2.31-.36-.78 1.26-1.44 2.16-1.995 2.7-.135.12-.3.225-.495.3l.285.99c1.29-.165 2.655-.45 4.065-.87.06.24.12.495.18.75l.9-.24c-.27-1.11-.57-2.085-.9-2.94zm.255 3.42-.84.27c.315.78.6 1.665.87 2.655l.9-.39c-.27-.9-.57-1.755-.93-2.535zm.465-7.41v1.035h3.63v2.28h-3.225v1.035h7.545v-1.035h-3.255v-2.28h3.585v-1.035h-3.585v-1.92H25.69v1.92h-3.63zm7.47 5.805h-6.54v6.015h1.05v-.69h4.44v.69h1.05v-6.015zm-5.49 4.305v-3.285h4.44v3.285h-4.44zM27.955 128.35v1.74h-8.58v-1.74h8.58zm-8.58 2.73h9.675v-3.75H18.295v4.98c-.015 3.015-.555 5.475-1.605 7.395l.84.735c1.215-2.265 1.83-4.98 1.845-8.13v-1.23zm8.79 9.21c.57 0 .99-.09 1.26-.27.3-.225.51-.825.6-1.815l-.945-.315c-.06.69-.18 1.095-.36 1.245-.15.105-.39.165-.735.165H25.03c-.285 0-.42-.18-.42-.54v-1.14l5.25-.48v-.96l-5.25.48v-1.275l4.29-.39v-.915l-4.29.39v-1.275c1.41-.18 2.745-.42 4.02-.705l-.495-.84c-2.16.51-4.83.84-8.025.99l.315.885a68.81 68.81 0 0 0 3.105-.21v1.245l-3.165.285v.93l3.165-.285v1.275l-3.855.36v.945l3.855-.345v1.26c0 .87.39 1.305 1.2 1.305h3.435z"/></g><path fill="#FFF" opacity=".3" d="m45 83-8 7V76z"/></g></svg>';

		//scaler.id = "epubjs-alert-" + uuid();
		alert.classList.add("epub-alert");

		if(width){
			alert.style.width = width;
		}

		if(height){
			alert.style.height = height;
		}

		alert.style.position = "fixed";
		alert.style.top = 0;
		alert.style.left = 0;
		alert.style.overflow = "hidden";
		alert.style.pointerEvents = "none";
		alert.style.zIndex = 2;

		return alert;
	}

	showAlert(name){
		if(!this._isShowingAlert){
			this._isShowingAlert = true;
			let $alert = $(`svg.epub-alert-${name}`);
			switch(name){
				case 'v-start': $alert.animate({ top: 100 }, "slow", ()=>{
									this.resetAlert(name);
								});
								break;
				case 'v-end': $alert.animate({ bottom: 120 }, "slow", ()=>{
									this.resetAlert(name);
								});
							  	break;
				case 'h-start': $alert.animate({ right: 32 }, "slow", ()=>{
									this.resetAlert(name);
								});
								break;
				case 'h-end': $alert.animate({ left: 32 }, "slow", ()=>{
									this.resetAlert(name);
								});
							  	break;
			}
		}
	}

	resetAlert(name){
		setTimeout(() => {
			let $alert = $(`svg.epub-alert-${name}`);
			switch(name){
				case 'v-start': $alert.animate({ top: -57 }, "fast", ()=>{
									this._isShowingAlert = false;
								});
								break;
				case 'v-end': $alert.animate({ bottom: -57 }, "fast", ()=>{
									this._isShowingAlert = false;
								});
							  	break;
				case 'h-start': $alert.animate({ right: -57 }, "fast", ()=>{
									this._isShowingAlert = false;
								});
								break;
				case 'h-end': $alert.animate({ left: -57 }, "fast", ()=>{
									this._isShowingAlert = false;
								});
							  	break;
			}
		},1000);
	}

	createScaler(options){
		let height  = options.height;// !== false ? options.height : "100%";
		let width   = options.width;// !== false ? options.width : "100%";
		let overflow  = options.overflow || false;
		let axis = options.axis || "vertical";
		let direction = options.direction;

		extend(this.settings, options);

		if(options.height && isNumber(options.height)) {
			height = options.height + "px";
		}

		if(options.width && isNumber(options.width)) {
			width = options.width + "px";
		}

		// Create new scaler element
		let scaler = document.createElement("div");

		//scaler.id = "epubjs-scaler-" + uuid();
		scaler.classList.add("epub-scaler");

		// Style Element
		scaler.style.wordSpacing = "0";
		scaler.style.lineHeight = "0";
		scaler.style.verticalAlign = "top";
		scaler.style.position = "relative";
		scaler.style.transformOrigin = "left top";

		//set flexWrap
		if(axis === "horizontal") {
			// container.style.whiteSpace = "nowrap";
			scaler.style.display = "flex";
			scaler.style.flexDirection = "row";
			scaler.style.flexWrap = "nowrap";
		}
		if(this._rendition._layout.name === "pre-paginated"){
			//固定版
			scaler.style.flexWrap = "wrap";	
		}

		if(width){
			scaler.style.width = width;
		}

		if(height){
			scaler.style.height = height;
		}

		if (overflow) {
			if (overflow === "scroll" && axis === "vertical") {
				if(this._rendition._layout.name === "pre-paginated"){
					//固定版
					scaler.style["overflow-y"] = overflow;
					scaler.style["overflow-x"] = (this._rendition.settings.isDomTriggerByTouch) ? overflow : "hidden";
				}else{
					//流動版
					scaler.style["overflow-y"] = overflow;
					scaler.style["overflow-x"] = (this._rendition.settings.isDomTriggerByTouch) ? overflow : "hidden";
				}
			} else if (overflow === "scroll" && axis === "horizontal") {
				if(this._rendition._layout.name === "pre-paginated"){
					//固定版
					scaler.style["overflow-y"] = overflow;
					scaler.style["overflow-x"] = (this._rendition.settings.isDomTriggerByTouch) ? overflow : "hidden";
				}else{
					//流動版
					scaler.style["overflow-y"] = (this._rendition.settings.isDomTriggerByTouch) ? overflow : "hidden";
					scaler.style["overflow-x"] = overflow;
				}
			} else {
				scaler.style["overflow"] = overflow;
			}
		}

		if (direction) {
			scaler.dir = direction;
			scaler.style["direction"] = direction;
		}

		if (direction && this.settings.fullsize) {
			document.body.style["direction"] = direction;
		}

		return scaler;
	}

	contentTransform(transformTarget = null, ...originTarget){
		let scaler = this.getScaler();
		let style = window.getComputedStyle(scaler);
		let matrix = style['transform'] || style.webkitTransform || style.mozTransform;
		let origin = style['transformOrigin'] || style.webkitTransformOrigin || style.mozTransformOrigin;
		let transform = {
			scale:1,
			translateX:0,
			translateY:0,
			originX:0,
			originY:0
		}
		if (!(!matrix || matrix === 'none' || typeof matrix === 'undefined')) {
			let matrixType = matrix.includes('3d') ? '3d' : '2d';
			let matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');
			if (matrixType === '2d') {
				transform = Object.assign(transform, {
					scale:parseFloat(matrixValues[3]),
					translateX:parseFloat(matrixValues[4]),
					translateY:parseFloat(matrixValues[5])
				});
			}else{
				transform = Object.assign(transform, {
					scale:parseFloat(matrixValues[5]),
					translateX:parseFloat(matrixValues[6]),
					translateY:parseFloat(matrixValues[7])
				});
			}
		}
		if (!(!origin || origin === 'none' || typeof origin === 'undefined')) {
			let orginPo = origin.replace(/px/g, '').split(' ');
			transform = Object.assign(transform, {
				originX:parseFloat(orginPo[0]),
				originY:parseFloat(orginPo[1])
			});
		}

		let originX = (originTarget && originTarget.length === 2) ? originTarget[0] : transform.originX;
		let originY = (originTarget && originTarget.length === 2) ? originTarget[1] : transform.originY;
		let originValue = `${originX}px ${originY}px`;

		let scale = (transformTarget !== null && transformTarget.scale) ? transformTarget.scale : transform.scale;
		let translateX = (transformTarget !== null && transformTarget.translateX) ? transformTarget.translateX : transform.translateX;
		let translateY = (transformTarget !== null && transformTarget.translateY) ? transformTarget.translateY : transform.translateY;
		let transformValue = '';
		if(scale == 1){
			/*if(this._rendition.manager.name === "continuous"){
				this._rendition.manager.scrollTo(translateX, translateY, true);
			}*/
			//console.log("reset:", translateX, translateY);
			//this.container.dir = "ltr";
			transformValue = `none`;
		}else{
			transformValue = `translateX(${translateX}px) translateY(${translateY}px) scale(${scale})`;
		}

		if(transformTarget){
			if(scale !== transform.scale || translateX !== transform.translateX || translateY !== transform.translateY){
				if(originTarget && originTarget.length){
					scaler.style.transformOrigin = originValue;
				}
				scaler.style.transform = transformValue;
			}
		}else if(originTarget && originTarget.length){
			scaler.style.transformOrigin = originValue;
		}else{
			return transform;
		}

	}

	contentScaleTo(scale){
		//let container = this.getContainer();
		let scaler = this.getScaler();
		scaler.style.transform = `scale(${scale})`;
		//let scalerRect = scaler.getBoundingClientRect();
		//console.log(scalerRect);
		//console.log(container.scrollWidth, container.scrollHeight);
	}

	getScaler() {
		return this.scaler;
	}

	onResize(func){
		// Only listen to window for resize event if width and height are not fixed.
		// This applies if it is set to a percent or auto.
		if(!isNumber(this.settings.width) ||
			 !isNumber(this.settings.height) ) {
			this.resizeFunc = throttle(func, 50);
			window.addEventListener("resize", this.resizeFunc, false);
		}
	}

	onOrientationChange(func){
		this.orientationChangeFunc = func;
		$( window ).on( "orientationchange", this.orientationChangeFunc );
		//window.addEventListener("orientationchange", this.orientationChangeFunc, false);
	}

	getScalerSize() {
		let scalerSize = null;
		let scaler = this.getScaler();
		if(scaler){
			scalerSize = scaler.getBoundingClientRect();
		}
		return scalerSize;
	}

	updateCreate(options){
		//加入scaler, 所以讓 container 的方向永遠維持 ltr, 便於縮放計算
		this.container.dir = "ltr";
		this.container.style["direction"] = "ltr";

		if(this._rendition._layout.name === "pre-paginated"){
			//固定版
			this.container.style.flexWrap = "wrap";
		}

		let overflow  = options.overflow || false;
		let axis = options.axis || "vertical";
		if (overflow) {
			if (overflow === "scroll" && axis === "vertical") {
				if(this._rendition._layout.name === "pre-paginated"){
					//固定版
					this.container.style["overflow-y"] = overflow;
					this.container.style["overflow-x"] = (this._rendition.settings.isDomTriggerByTouch) ? overflow : "hidden";
				}else{
					//流動版
					this.container.style["overflow-y"] = overflow;
					this.container.style["overflow-x"] = (this._rendition.settings.isDomTriggerByTouch) ? overflow : "hidden";
				}
			} else if (overflow === "scroll" && axis === "horizontal") {
				if(this._rendition._layout.name === "pre-paginated"){
					//固定版
					this.container.style["overflow-y"] = overflow;
					this.container.style["overflow-x"] = (this._rendition.settings.isDomTriggerByTouch) ? overflow : "hidden";
				}else{
					//流動版
					this.container.style["overflow-y"] = (this._rendition.settings.isDomTriggerByTouch) ? overflow : "hidden";
					this.container.style["overflow-x"] = overflow;
				}
			} else {
				this.container.style["overflow"] = overflow;
			}
		}
	}

	axis(axis) {
		if(axis === "horizontal") {
			this.container.style.display = "flex";
			this.container.style.flexDirection = "row";
			if(this._rendition._layout.name === "pre-paginated"){
				//固定版
				this.container.style.flexWrap = "wrap";
			}else{
				//流動版
				this.container.style.flexWrap = "nowrap";
			}
			
		} else {
			this.container.style.display = "block";
		}
		this.settings.axis = axis;
	}

	direction(dir) {
		if (this.container) {
			this.container.dir = dir;
			this.container.style["direction"] = dir;
		}

		if (this.scaler) {
			this.scaler.dir = dir;
			this.scaler.style["direction"] = dir;
		}

		if (this.settings.fullsize) {
			document.body.style["direction"] = dir;
		}
		this.settings.dir = dir;
	}

	overflow(overflow) {
		if (this.container) {
			if (overflow === "scroll" && this.settings.axis === "vertical") {
				if(this._rendition._layout.name === "pre-paginated"){
					//固定版
					this.container.style["overflow-y"] = overflow;
					this.container.style["overflow-x"] = "hidden";
				}else{
					//流動版
					this.container.style["overflow-y"] = overflow;
					this.container.style["overflow-x"] = "hidden";
				}
			} else if (overflow === "scroll" && this.settings.axis === "horizontal") {
				if(this._rendition._layout.name === "pre-paginated"){
					//固定版
					this.container.style["overflow-y"] = overflow;
					this.container.style["overflow-x"] = "hidden";
				}else{
					//流動版
					this.container.style["overflow-y"] = "hidden";
					this.container.style["overflow-x"] = overflow;
				}
			} else {
				this.container.style["overflow"] = overflow;
			}
		}
		this.settings.overflow = overflow;
	}

	destroy() {
		this._rendition = undefined;
		this.container.removeChild(this.scaler);
		//super.destroy();
		var base;

		if (this.element) {

			if(this.settings.hidden) {
				base = this.wrapper;
			} else {
				base = this.container;
			}

			if(this.element.contains(this.container)) {
				this.element.removeChild(this.container);
			}

			window.removeEventListener("resize", this.resizeFunc);
			$( window ).off( "orientationchange", this.orientationChangeFunc );
			//window.removeEventListener("orientationChange", this.orientationChangeFunc);
		}
	}
}

export default ExStage;